<script>
    export let name;
    export let key;
    let apiURL = _app.env.API_URL;
</script>

<!-- svelte-ignore a11y-media-has-caption -->
<video id="video" width="800" height="500" src={`${apiURL}/stream?video=${name}&key=${key}`} autoplay="true" controls="true" playsinline />
